import React from "react";

import { StyledBreadcrumb } from "@aureskonnect/react-ui";
import PageTitle from "@components/Common/PageTitle";


export default function BreadcrumbOptions({ currentLink }: any) {
  return (
    <React.Fragment>
      <PageTitle title="Reporting"/>
      <div>
        <StyledBreadcrumb items={currentLink} />
      </div>
    </React.Fragment>
  );
}
